const actionTypes = {
    TOAST_DISPLAY: 'TOAST_DISPLAY',
    TOAST_HIDE: 'TOAST_HIDE'
};

export default actionTypes;
